import React from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import orderBy from 'lodash/orderBy'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import remove from 'lodash/remove'
import last from 'lodash/last'
import slice from 'lodash/slice'
import database from '../common/database.js'
import PostList from './post-list.jsx'
import { connect } from 'react-redux'
import SocialShareModal from './social-share-modal'

class NewsFeed extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      posts: [],
      cutTime: -(Date.now()),
      globalCount: 0,
      localCount: 0,
      loading: false,
      showViewMore: true,
      showMobile: true,
      showShareModal: false,
      shareUrl: null,
      shareTitle: null,
      shareText: null
    }
  }

  hideShare = () => {
    this.setState({
      showShareModal: false,
      url: null,
      shareTitle: null,
      shareText: null
    });
  }

  showShareModal = (url, title, text) => {
    console.log("Calling here ", url);
    this.setState({
      showShareModal: true,
      shareUrl: url,
      shareTitle: title,
      shareText: text
    });
  }

  getPosts () {
    const cutPoint = 6
    const itemsByRow = 3
    const component = this
    const inboxPromises = []

    let globalRef = database().charityDatabase.child('inboxes').child('global')
    inboxPromises.push(globalRef.startAt(component.state.cutTime).orderByValue().limitToFirst(cutPoint).once('value'))

    Promise.all(inboxPromises).then((values) => {
      let globalQuery = []
      let localQuery = []
      let globalSnapshot = values[0]

      globalSnapshot.forEach(function (childSnapshot) {
        globalQuery.push({id: childSnapshot.key, date: childSnapshot.val()})
      })

      let queries = orderBy(globalQuery.concat(localQuery), 'date', 'asc')
      if (queries.length > cutPoint) { queries = queries.slice(0, cutPoint) }
      let postsPromises = []
      let globalCount = component.state.globalCount
      let localCount = component.state.localCount

      for (let query of queries) {
        if (find(globalQuery, {id: query.id})) { globalCount += 1 }
        if (find(localQuery, {id: query.id})) { localCount += 1 }
        let postRef = database().charityDatabase.child('publishedPosts').child(query.id)
        postsPromises.push(postRef.once('value'))
        postRef.on('value', function (snapshot) {
          if (snapshot.val() !== null) {
            component.updatePost(snapshot)
          }
        })
      }

      Promise.all(postsPromises).then((values) => {
        let posts = component.state.posts
        let newPosts = []

        for (let snapshot of values) {
          if (snapshot.val() !== null) {
            let newPost = JSON.parse(JSON.stringify(snapshot.val()))
            newPost.id = snapshot.key
            let index = findIndex(queries, {id: newPost.id})
            newPost.publishedOn = queries[index].date
            if (!find(posts.concat(newPosts), {id: newPost.id})) {
              newPosts.push(newPost)
            }
          }
        }

        if (values.length === cutPoint && newPosts.length < cutPoint) {
          let diff = newPosts.length % itemsByRow
          if (diff !== 0) {
            newPosts = orderBy(slice(newPosts, 0, newPosts.length - diff), 'publishedOn', 'asc')
          }
        }

        posts = orderBy(posts.concat(newPosts), 'publishedOn', 'asc')
        component.setState({
          posts: posts,
          cutTime: last(posts).publishedOn,
          globalCount: globalCount,
          localCount: localCount,
          loading: false
        })

        if (postsPromises.length < cutPoint) { component.setState({showViewMore: false}) }
      })

      globalRef.orderByValue().limitToFirst(globalCount)
        .on('child_added', function (snapshot) {
          component.addPost(snapshot)
        })

      database().charityDatabase.child('publishedPosts').on('child_removed', function (snapshot) {
        component.removePost(snapshot)
      })
    })
  }

  addPost (snapshot) {
    let promises = []
    let component = this
    let publishedOn = snapshot.val()
    let newPostRef = database().charityDatabase.child('publishedPosts').child(snapshot.key)
    promises.push(newPostRef.once('value'))
    Promise.all(promises).then((values) => {
      for (let snapshot of values) {
        if (snapshot.val() !== null) {
          let newPost = JSON.parse(JSON.stringify(snapshot.val()))
          newPost.id = snapshot.key
          newPost.publishedOn = publishedOn
          let actualPosts = component.state.posts
          if (!find(actualPosts, {id: newPost.id}) && newPost.publishedOn < component.state.cutTime) {
            actualPosts.push(newPost)
            actualPosts = orderBy(actualPosts, 'publishedOn', 'asc')
            component.setState({posts: actualPosts})
            newPostRef.on('value', function (postSnapshot) {
              if (postSnapshot.val() !== null) {
                component.updatePost(postSnapshot)
              }
            })
          }
        }
      }
    })
  }

  updatePost (snapshot) {
    let newPost = JSON.parse(JSON.stringify(snapshot.val()))
    newPost.id = snapshot.key
    let actualPosts = this.state.posts
    if (find(actualPosts, {id: newPost.id})) {
      let index = findIndex(actualPosts, {id: newPost.id})
      newPost.publishedOn = actualPosts[index].publishedOn
      actualPosts.splice(index, 1, newPost)
      this.setState({posts: actualPosts})
    }
  }

  removePost (snapshot) {
    let actualPosts = this.state.posts
    if (find(actualPosts, {id: snapshot.key})) {
      remove(actualPosts, {id: snapshot.key})
      this.setState({posts: actualPosts})
    }
  }

  loadMore () {
    this.setState({loading: true})
    this.getPosts()
  }

  componentDidMount () {
    if (window.sessionStorage && window.sessionStorage.getItem('fromApp')) {
      this.setState({
        showMobile: false
      })
    }
    this.loadMore()
  }

  render () {
    let postsHtml = []
    if (this.state.posts.length > 0) {
      for (let i = 0; i < this.state.posts.length; i++) {
        postsHtml.push(<PostList post={this.state.posts[i]} key={i} isOdd={((parseInt(i + 1) % 3) !== 0)} isNewsFeed
          showShareModal={this.showShareModal} />)
      }
    }
    let viewMoreHtml = null
    if (this.state.showViewMore) {
      if (this.state.loading) { viewMoreHtml = <div className='payment-gif' /> } else {
        viewMoreHtml =
          <Button bsSize='large' onClick={this.loadMore.bind(this)}>View More</Button>
      }
    }
    return (
      <div className='orange-container'>
        <div className='container'>
          <Row className='news-feed no-gutter'>
            <Col xs={12} className='main-title'>Latest News</Col>
            {postsHtml}
            <Col xs={12} className='actions margin-top'>
              {viewMoreHtml}
            </Col>
          </Row>
        </div>
        <SocialShareModal show={this.state.showShareModal} shareUrl={this.state.shareUrl} title={this.state.shareTitle} text={this.state.shareText} hide={this.hideShare}
                          disabledChannels={this.props.config.disabledShareChannel} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    config: state.config

  }
}

export default connect(mapStateToProps)(NewsFeed)
